import { styled, Text } from "@tamagui/core";
import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
const DEFAULT_SIZE = "regular",
  InternalHeader = styled(Text, {
    accessibilityRole: "header",
    color: "$text-primary",
    defaultVariants: {
      size: DEFAULT_SIZE
    },
    fontFamily: "$heading",
    fontWeight: "500",
    name: "TypographyHeader",
    role: "heading",
    variants: {
      size: {
        large: {
          fontSize: "$large",
          letterSpacing: "$large",
          lineHeight: "$large"
        },
        regular: {
          fontSize: "$regular",
          letterSpacing: "$regular",
          lineHeight: "$regular"
        }
      }
    }
  });
function levelToTag(level) {
  switch (level) {
    case 1:
      return "h1";
    case 2:
      return "h2";
    case 3:
      return "h3";
    case 4:
      return "h4";
    case 5:
      return "h5";
    case 6:
      return "h6";
  }
  return "h1";
}
const HeaderAncestorSizeContext = createContext(void 0);
function Header(props) {
  const {
      level,
      ...rest
    } = props,
    parentSize = useContext(HeaderAncestorSizeContext);
  if (parentSize !== void 0) {
    const {
      size,
      ...restWithoutSize
    } = rest;
    return /* @__PURE__ */jsx(InternalHeader, {
      size: size || parentSize,
      tag: "span",
      ...restWithoutSize
    });
  } else return /* @__PURE__ */jsx(HeaderAncestorSizeContext.Provider, {
    value: rest.size || DEFAULT_SIZE,
    children: /* @__PURE__ */jsx(InternalHeader, {
      ...rest,
      tag: levelToTag(level)
    })
  });
}
Header.displayName = "Typography.Header";
export { Header };
//# sourceMappingURL=Typography.Header.mjs.map
